
function Home() {
 
  return (
   
    <section className="home" id="home">
      
      <div className="nxjimage">
        <img src="./assests/full.jpg" alt="nxjimage.png" />
        {/* <img src="./assests/coding1.jpg" alt="coding1.jpg" /> */}
      </div>
      <div className="home3">
        <h3>
          I'm Varun <span className="span">Walia</span>
        </h3>
        <p>
          A passionate individual who always thrives to work on end to
          end
          products which develop sustainable and scalable social and technical
          systems to create impact.{" "}
        </p>
      
     
      </div>

      <div className="bottom">
        <h1>What I Do?</h1>
      </div>
      
      <div className="second-img">
      <img src="./assests/bottom.jpg" alt="bottom.jpg" />
      </div>
      <div className="para">
      <h1 className="">Full Stack Developer <span>    -Youtuber</span>    -Coder</h1>
      <p>⚡ Building resposive website front end using React-Redux</p>
      <p>⚡ Developing mobile applications using Flutter, React Native</p>
      <p>⚡ Creating application backend in Node, Express & Flask</p>
      </div>
      
      <div className="myimage">
      <div className="html-img">
      <a href="https://developer.mozilla.org/en-US/docs/Web/HTML" target="_blank">
         <img src="./assests/html.jpg" alt="html.jpg" />
         </a>
      </div>
      <div className="css-img">
      <a href="https://developer.mozilla.org/en-US/docs/Web/CSS" target="_blank">
        <img src="./assests/css.png" alt="css.png" />
        </a>
        </div>
      <div className="css-img">
      <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank">
        <img src="./assests/jss.jpg" alt="jss.jpg" />
        </a>
        </div>
      <div className="css-img">
      <a href="https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/Client-side_JavaScript_frameworks/React_getting_started" target="_blank">
        <img src="./assests/react.png" alt="react.png" />
        </a>
        </div>
      <div className="css-img">
      <a href="https://tailwindcss.com/docs/installation" target="_blank">
        <img src="./assests/tailwind.jpg" alt="tailwind.jpg" />
        </a>
        </div>
      <div className="css-img">
      <a href="https://openai.com/chatgpt" target="_blank">
        <img src="./assests/chatgpt.png" alt="chatgpt.png" />
        </a>
        </div>
        <div className="css-img">
        <a href="https://developer.mozilla.org/en-US/docs/Glossary/Git" target="_blank">
        <img src="./assests/git2.jpg" alt="git2.jpg" />
        </a>
        </div>
      <div className="css-img">
      <a href="https://www.canva.com/" target="_blank">
        <img src="./assests/canva1.jpg" alt="canva1.jpg" />
        </a>
        </div>

      
         </div>
      </section>
  
    
  );
}
export default Home;

 
    

 
    
